// extracted by mini-css-extract-plugin
export default {"h":"styles_h__cyS4p","p":"styles_p__Ph6PL"};